"use client"

import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingNotificationProps {
  isVisible: boolean;
  loadingStates: Array<{
    id: string;
    message: string;
    itemId?: string;
    userId: string;
    userEmail?: string;
  }>;
  onComplete?: () => void;
}

export function LoadingNotification({ isVisible, loadingStates, onComplete }: LoadingNotificationProps) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
    } else {
      // Delay hiding to allow for smooth animation
      const timer = setTimeout(() => {
        setShouldRender(false);
        onComplete?.();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onComplete]);

  if (!shouldRender) return null;

  return (
    <div className={`
      fixed bottom-4 right-4 z-50 
      bg-white/95 border border-gray-200 
      rounded-lg shadow-lg p-4 
      transition-all duration-300 ease-in-out
      ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}
      max-w-sm
    `}>
      <div className="flex items-center gap-3 mb-3">
        <Loader2 className="h-5 w-5 animate-spin text-blue-600" />
        <div className="text-sm font-medium text-gray-900">
          Work Orders Being Updated
        </div>
      </div>
      
      {loadingStates.length > 0 && (
        <div className="space-y-2">
          {loadingStates.map((state) => (
            <div key={state.id} className="flex items-start gap-2 text-sm">
              <div className="w-2 h-2 bg-blue-500 rounded-full mt-1.5 flex-shrink-0"></div>
              <div className="flex-1 min-w-0">
                <div className="text-gray-700 truncate">{state.message}</div>
                {state.userEmail && (
                  <div className="text-xs text-gray-500">
                    by {state.userEmail}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
} 